import styled from 'styled-components';

export default styled.div`
  && {
    .section {
      padding: 30px 65px;
    }
  }
`;
